import React from "react";
import LayoutAssessor from "./LayoutAssessor";
import LayoutReocrding from "./LayoutReocrding";
import TestQuilljs from "./TestQuilljs";
import ModalLeaveSession from "../SessionMethodVideoModul/views/molekuls/Modal/ModalLeaveSession";
import { durationTime } from "../../general/functions/datetimeFunction";
import { useEffect } from "react";
import { useState } from "react";
import SessionEndView from "../SessionMethodVideoModul/views/parts/SessionEndView";
const moment = require("moment");

export default function ComponentTest() {
  const [seconds, setSeconds] = useState(0);
  const [text, setText] = useState("");
  useEffect(() => {
    let timeStart = moment().unix();
    const interval = setInterval(() => {
      setText(durationTime(timeStart));
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const handleClose = () => {
    window.close();
  };
  return (
    <>
      <p>{text}</p>
      <button
        onClick={(e) => {
          e.preventDefault();
          handleClose();
        }}
      >
        Tutup
      </button>
      <SessionEndView />
      {/* <LayoutAssessor /> */}
      {/* <TestQuilljs /> */}
      {/* <ModalLeaveSession /> */}
    </>
  );
}
